import { Box } from '@mui/material';
import React from 'react';
import Image404 from '@src/assets/icons/404.svg';
import '../../styles/404.css';
import styled from 'styled-components';
import logo from '@src/assets/Logo/ylPartsLogo.png';

const StyledBox = styled(Box)`
	h3 {
		color: var(--default-text-color);
		font-size: 36px;
		font-weight: 600;
		line-height: 46.8px;
	}
	p {
		color: var(--color-font-grey);
		text-align: center;
		font-size: 20px;
		font-weight: 600;
	}
`;

const StyledLogo = styled.img`
	position: absolute;
	top: 15px;
	left: 15px;
	height: 40px;
	width: 190px;
`;

const Page404 = () => {
	return (
		<StyledBox
			display="flex"
			gap="12px"
			flexDirection="column"
			alignItems="center"
			justifyContent="center"
			className="container"
		>
			<StyledLogo src={logo} alt="Logo" loading="lazy" />
			<img src={Image404} alt="404" />
			<h3>404 page error</h3>
			<p>The page you are looking for is not found.</p>
		</StyledBox>
	);
};

export default Page404;
